import { Box, styled } from '@withjoy/joykit';
import type { ButtonOverrides } from '@withjoy/joykit/components/ButtonV2/Button.types';

export const StyledSelectWrapper = styled(Box)`
  [role='combobox'] {
    div:after,
    input:enabled:hover {
      border-color: #333333;
    }
  }
`;

export const StyledAmountButtonsContainer = styled(Box)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
`;

export const getAmountButtonOverrides = (isSelected: boolean): ButtonOverrides => ({
  Root: {
    props: {
      border: '2px solid',
      borderRadius: 3,
      borderColor: isSelected ? 'mono14' : 'mono5',
      backgroundColor: 'transparent',
      color: 'inherit',
      _hover: {
        backgroundColor: '#4d4d4d1a',
        borderColor: isSelected ? 'mono14' : 'mono5',
      },
      _active: {
        backgroundColor: '#59595933',
        borderColor: isSelected ? 'mono14' : 'mono5',
      },
    },
  },
});
